export const COOKIE_CONSENT_STORAGE_KEY = 'reffconnect_cookie_consent_v1';

export type StoredCookieConsent = {
  v: 1;
  analytics: boolean;
  decidedAt: number;
};

export function readCookieConsent(): StoredCookieConsent | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<StoredCookieConsent>;
    if (parsed.v !== 1 || typeof parsed.analytics !== 'boolean' || typeof parsed.decidedAt !== 'number') {
      return null;
    }
    return parsed as StoredCookieConsent;
  } catch {
    return null;
  }
}

export function writeCookieConsent(analytics: boolean): StoredCookieConsent {
  const value: StoredCookieConsent = {
    v: 1,
    analytics,
    decidedAt: Date.now(),
  };
  window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(value));
  return value;
}

/** Sync Google tag consent flags (GA4 Consent Mode). Safe if gtag is absent. */
export function applyGtagConsent(analyticsGranted: boolean): void {
  if (typeof window === 'undefined') return;
  const gtag = window.gtag;
  if (typeof gtag !== 'function') return;
  gtag('consent', 'update', {
    analytics_storage: analyticsGranted ? 'granted' : 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}
